import { QuotaInfo } from "@models/services/booking";

export const BOOKING_CONSTANTS = {
  INTERVAL_15_MINUTES: 15,
  INTERVAL_30_MINUTES: 30,
  MINS_IN_HOUR: 60,
  ODD_MINUTE_MARKS: [15, 45],
  ROUNDED_0_MINUTE_MARK: 0,
  ROUNDED_30_MINUTE_MARK: 30,
  TEXT: "Text",
  WIDTH_PER_SLOT: 15,
};

export const GUEST_COUNT_INVALID_CHARACTERS = ["-", ".", "+", "e", "E"];

export const PAYMENT_OPTIONS = {
  CARD: "card",
  INSTANT_PAYMENT: "instant-payment",
  TWINT: "twint",
};

export const PAYMENT_STATUS = {
  BILLED: "BILLED",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  INITIATED: "INITIATED",
  PAID: "PAID",
  PARTPAYMENT: "PARTPAYMENT",
  SUCCESS: "SUCCESS",
  UNTRACKED: "UNTRACKED",
};

export const SOURCE = {
  PWA: "pwa",
  WEB: "web",
};

export const USER_TYPE = {
  EXTERNALUSER: "external-users",
  GUEST: "guests",
  MEMBER: "members",
};

export const USER_ROLE = {
  GUEST_ROLE: "ROLE_GUEST",
  ORGANIZER_ROLE: "ROLE_ORGANIZER",
};

export const HOLIDAY_TREAT_AS_TYPE = {
  CLOSED: "CLOSED",
  PARTIALLY_CLOSED: "PARTIALLY-CLOSED",
};

export const TIME_CONSTANTS = {
  END_OF_DAY: "23:59",
  INVALID_END: "24:00",
  START_OF_DAY: "00:00",
  START_OF_DAY_15_MINUTE_MARK: "00:15:00",
};

export const BOOKING_ADVANCE_DURATION = {
  DAYS: "DAYS",
  HOURS: "HOURS",
  MINUTES: "MINUTES",
};

export const QUOTA_INFO_ARRAY: (keyof QuotaInfo)[] = [
  "MAX_ACTIVE_BOOKING",
  "MAX_BOOKING",
];
